<template>
    <v-layout row wrap>

        <v-flex xs12>
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{'Equipment Summary'|translate}}
                    <v-spacer></v-spacer>
                    <equipment-context-menu :equipment="equipment" :date-range="dateRange"
                                            fault model-summary notification-breakdown
                    >
                        <v-list-tile @click="exportAll()">
                            <v-list-tile-title>{{'Export as PDF'|translate}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="!showPlots" @click="displayPlots()">
                            <v-list-tile-title>{{'Display equipment plots'|translate}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="!showAnomaly" @click="showAnomaly=true">
                            <v-list-tile-title>{{'Display anomalies'|translate}}</v-list-tile-title>
                        </v-list-tile>
                    </equipment-context-menu>
                </v-card-title>
                <div class="carnot-equip-summary-holder">
                <v-layout row wrap class="pl-3">
                    <v-flex xs12 md6>
                        <date-range-selector class="mr-4" v-model="dateRange" @change="handleDateChange()" ></date-range-selector>
                        <equipment-selector v-on:ect="handleDateChange()" v-model="equipment"></equipment-selector>
                        <p v-if="floor"><strong>{{'Floor'|translate}} : </strong>{{floor}}</p>
                        <p v-if="notes"><strong>{{'Notes'|translate}} : </strong>{{notes}}</p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="fullEquip&&fullEquip.graphic_id">
                        <equipment-graphic-renderer :graphic-id="fullEquip.graphic_id" :selected-equipments="[equipment]"></equipment-graphic-renderer>
                    </v-flex>
                    <v-flex xs12 v-show="loading">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-flex>
                </v-layout>
                    <v-layout v-if="!loading" row wrap>
                        <v-flex xs12 v-if="showAnomaly">
                            <anomaly :range="dateRange" :equipment="equipment"></anomaly>
                        </v-flex>
                        <v-flex xs12>
                            <notifications :equipment-filter="equipment" :date-range="dateRange"></notifications>
                        </v-flex>
                        <v-flex xs12>
                            <maintenance-record :equipment-filter="equipment" :date-range="dateRange"></maintenance-record>
                        </v-flex>
                        <v-flex xs12 v-if="fullVariableList&&showPlots">
                            <data3-chart v-for="(unitVars,unitName) in fullVariableList" :key="unitName"
                                         :layout-overrides="{height:300,margin:layoutOverrides.margin,shapes:layoutOverrides.shapes,yaxis:{title:unitName,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                                         :on-only="false"
                                         :x-axis="'timestamp'"
                                         ref="plots"
                                         just-plot
                                         disable-responsive
                                         :show-export="false"
                                         :data-payload="unitVars"
                                         :date-range="dateRange"></data3-chart>
                        </v-flex>
                    </v-layout>



                </div>
            </v-card>
        </v-flex>

    </v-layout>
</template>

<script>
    import DateRangeSelector from "../components/DateRangeSelector";
    import moment from 'moment'
    import EquipmentSelector from "../components/EquipmentSelector";
    import Anomaly from "../components/Anomaly";
    import Notifications from "./Notifications";
    import MaintenanceRecord from "./MaintenanceRecord";
    import EquipmentContextMenu from "../components/EquipmentContextMenu";
    import Data3Chart from "../components/Data3Chart";
    import EquipmentGraphicRenderer from "../components/EquipmentGraphicRenderer";
    import printer from "../components/mixins/printer";
    export default {
        name: 'EquipmentPlots',
        components: {Data3Chart,DateRangeSelector,EquipmentSelector,Anomaly,Notifications,MaintenanceRecord,EquipmentContextMenu,EquipmentGraphicRenderer},
        mixins:[printer],

        data () {
            return {
                loading:true,
                rule:null,
                showPlots:false,
                showAnomaly:false,
                equipment:null,
                fullEquip:null,
                dateRange: {start: null, end: null},
                equipmentName: null,
                faultDesc: null,
                highlightTime:null,
                notes:null,
                floor:null,
                relevantVariables:null,
                faultName:null,
                variableList:[],
                layoutOverrides:{},
                layout1:null,
                data1:null,
                points:[],
                plots:[],
                allVars:null,
                fullVariableList:null,
            }
        },
        methods:{
            jumpToNotification(value,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.dateRange.start,
                        rangeEnd: this.dateRange.end,
                    }
                }
                output.query[facet]=value
                this.$router.push(output)
            },
            handleDateChange(){
              this.renderPlots()
            },
            displayPlots(){
                let me=this
                this.showPlots=true
                setTimeout(function(){ me.initPlotlySync() }, 4000);
            },
            relayout(ed) {
                let plots=[]
                for (let item of this.$refs.plots){
                    if (item.$refs.plotly){
                        plots.push(item.$refs.plotly.$refs.container)
                    }
                }
                for (let plot of plots){
                    if(plot.layout) {
                        let x = plot.layout.xaxis;
                        if (x.range[0] !== ed["xaxis.range[0]"] || x.range[1] !== ed["xaxis.range[1]"]) {
                            plot.relayout(ed);
                        }
                    }
                }
            },
            initPlotlySync(){
                let plots=[]
                let me=this;
                if(!this.$refs.plots||this.$refs.plots.length<=1){
                    setTimeout(function(){ me.initPlotlySync()}, 2000);
                } else {
                    for (let item of this.$refs.plots){
                        if (item.$refs.plotly){
                            plots.push(item.$refs.plotly.$refs.container.$el)
                        }
                    }
                    me.plots=plots;
                    plots.forEach(div => {
                        if(div.on) {
                            div.on("plotly_relayout", ed => {
                                if (!ed.autosize) {
                                    let newl = {
                                        "xaxis.range[0]": div.layout.xaxis.range[0],
                                        "xaxis.range[1]": div.layout.xaxis.range[1],
                                    }
                                    me.relayout(newl);
                                }
                            });
                        }
                    });
                }
            },
            async renderPlots(){
                if(!this.equipment){
                    return
                }
                let me=this;
                me.loading=true
                me.data1=null

                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    if (this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name===this.equipment){
                        this.allVars=this.$store.state.pointsListStore.pointsList.sensors[i]
                        this.notes=this.$store.state.pointsListStore.pointsList.equipment_details[i].notes
                        this.floor=this.$store.state.pointsListStore.pointsList.equipment_details[i].floor
                        this.fullEquip=this.$store.state.pointsListStore.pointsList.equipment_details[i]
                        break
                    }
                }
                if(this.allVars){
                    let newVarList={};
                    for (let varName of this.allVars){
                        let unit = this.getUnit(varName)
                        if (!newVarList[unit]) {
                            newVarList[unit] = [];
                        }
                        newVarList[unit].push({
                            'filters': {
                                equipment_name: this.equipment,
                                sensor_name: varName,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            seriesOverrides:{
                                type:'scatter',
                                opacity:1,
                                xbins: {
                                    size: 1
                                }
                            },
                        })
                    }
                    this.fullVariableList=newVarList
                }
                this.layoutOverrides={
                    title:"Relevant variables",
                    xaxis: {
                        title: '',
                    },
                    yaxis:{
                        fixedrange: true
                    },
                    margin:{
                        t: 30,
                        b:0
                    },
                    height:300,
                    showlegend:true,
                    legend: {
                        orientation:'h',
                        y: -0.2
                    },
                    hoverlabel: {
                        namelength: -1
                    },
                    hovermode:"x",
                    shapes: this.highlightTime ? [
                        {
                            type: 'line',
                            x0:this.highlightTime,
                            y0: 0,
                            x1: this.highlightTime,
                            y1: 1,
                            yref: 'paper',
                            line:{
                                color: 'red',
                                width: 4,
                            }
                        }
                    ] : [],
                }
                this.loading=false
                if(this.showPlots) {
                    setTimeout(function () {
                        me.initPlotlySync()
                    }, 4000);
                }
            },
            async exportAll(){
                let title = this.$store.state.pointsListStore.pointsList.facility_name + "=" + this.equipment+ "=" + this.dateRange.start
                await this.printPage('.carnot-equip-summary-holder', title)
            },
            getUnit(varName){
                for (let point of this.$store.state.pointsListStore.pointsList.points_list){
                    if(point.sensor_name===varName&&point.equipment_name===this.equipment){
                        if(point.unit){return point.unit}
                        break
                    }
                }
                if(varName.toLowerCase().includes("tem")){
                    return "°C"
                } else if(varName.toLowerCase().includes("press")){
                    return "kPa"
                } else if(varName.toLowerCase().includes("status")){
                    return "status"
                } else if(varName.toLowerCase().includes("_hr")){
                    return "hour"
                }
                return "";
            }
        },
        async beforeMount(){
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            this.equipment = _.get(this.$route.query, 'equipment', null)
            let rangeStart = _.get(this.$route.query, 'rangeStart', null)
            let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
            if (!!rangeStart) {
                this.dateRange = {start: rangeStart, end: rangeEnd}
            } else if(maxDate){
                this.dateRange={
                    start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                    end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
                }
            }

            this.renderPlots()
        },

    }
</script>
